import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserModel } from './models/UserModel';

interface UserState {
  user: UserModel | null;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserModel>) {
      state.user = action.payload;
    },
    updateUser(state, action: PayloadAction<Partial<UserModel>>) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    clearUser(state) {
      state.user = null;
    },
    updateEmailSent(state, action: PayloadAction<{email_sent_number: number}>) {
      if (state.user) {
        state.user.email_sent_number = action.payload.email_sent_number;
      }
    },
  },
});

export const { setUser, updateUser, clearUser, updateEmailSent } = userSlice.actions;
export default userSlice.reducer;
